/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPaymentAccountRoleSimpleDto { 
    id?: number;
    insertTs?: string;
    role: UserPaymentAccountRoleSimpleDto.RoleEnum;
    acceptedOldAirtimeAgreement?: boolean;
    acceptedNewDataPlanAirtimeAgreement?: boolean;
    userAccountId?: number;
}
export namespace UserPaymentAccountRoleSimpleDto {
    export const RoleEnum = {
        Owner: 'OWNER',
        Viewer: 'VIEWER',
        Financial: 'FINANCIAL'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


